import React from "react";
import { motion } from "framer-motion";
import { TrendingUp } from "lucide-react";
import SectionHeading from "../SectionHeading";
import { StaggerGroup, StaggerItem } from "../Reveal";
import { CASE_STUDIES } from "../../data/site";

export const Work = () => {
  return (
    <section id="work" data-testid="work-section" className="relative py-24 md:py-32 bg-navy">
      <div className="container-x">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
          <SectionHeading
            overline="Featured Work"
            title="Outcomes, not just output"
            subtitle="Representative engagements showing how ATS turns problems into measurable results."
          />
          <span className="font-mono text-xs text-slate-500 shrink-0">* Placeholder projects — real case studies coming soon</span>
        </div>

        <StaggerGroup className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-6">
          {CASE_STUDIES.map((c) => (
            <StaggerItem key={c.title}>
              <motion.article
                whileHover={{ y: -8 }}
                transition={{ type: "spring", stiffness: 260, damping: 22 }}
                data-testid={`case-${c.industry.split(" ")[0].toLowerCase()}`}
                className="group glass rounded-3xl overflow-hidden h-full card-glow"
              >
                {/* device frame */}
                <div className="p-4 pb-0">
                  <div className="rounded-2xl overflow-hidden border border-white/10 bg-navy-deep">
                    <div className="flex items-center gap-1.5 px-4 py-3 border-b border-white/10">
                      <span className="w-2.5 h-2.5 rounded-full bg-red-400/70" />
                      <span className="w-2.5 h-2.5 rounded-full bg-yellow-400/70" />
                      <span className="w-2.5 h-2.5 rounded-full bg-green-400/70" />
                    </div>
                    <div className="relative aspect-[16/9] overflow-hidden">
                      <img
                        src={c.image}
                        alt={`${c.title} — ${c.industry}`}
                        loading="lazy"
                        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-navy-deep/70 to-transparent" />
                    </div>
                  </div>
                </div>

                <div className="p-8">
                  <div className="flex items-center justify-between gap-4 mb-4">
                    <span className="overline">{c.industry}</span>
                    <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-brand-orange/15 text-brand-orange font-head font-bold text-sm">
                      <TrendingUp size={14} /> {c.result}
                    </span>
                  </div>
                  <h3 className="font-head text-xl font-semibold text-white mb-4">{c.title}</h3>
                  <dl className="space-y-2 text-sm">
                    <div className="flex gap-3">
                      <dt className="font-mono text-xs text-slate-500 w-20 shrink-0 pt-0.5">Problem</dt>
                      <dd className="text-slate-300">{c.problem}</dd>
                    </div>
                    <div className="flex gap-3">
                      <dt className="font-mono text-xs text-slate-500 w-20 shrink-0 pt-0.5">Solution</dt>
                      <dd className="text-slate-300">{c.solution}</dd>
                    </div>
                  </dl>
                </div>
              </motion.article>
            </StaggerItem>
          ))}
        </StaggerGroup>
      </div>
    </section>
  );
};

export default Work;
